import { lazyPage, type ModulePlugin } from "@keel/core";

const orders = () => import("./Orders");
const deliveries = () => import("./Deliveries");
const slots = () => import("./Slots");
const OrdersList = lazyPage(orders, "OrdersList");
const OrderPage = lazyPage(orders, "OrderPage");
const DeliveriesList = lazyPage(deliveries, "DeliveriesList");
const DeliveryPage = lazyPage(deliveries, "DeliveryPage");
const NewOrderButton = lazyPage(slots, "NewOrderButton");
const CustomerOrdersTab = lazyPage(slots, "CustomerOrdersTab");

/** Sales: orders and deliveries. Ported from the prototype's `pages/sales`. */
const plugin: ModulePlugin = {
  key: "sales",
  records: { SalesOrder: "/orders/", DeliveryNote: "/deliveries/" },
  help: () => import("./help"),
  nav: [
    {
      group: "Sales",
      items: [
        { to: "/orders", label: "Orders", icon: "cart", perm: "sales.orders.read" },
        { to: "/deliveries", label: "Deliveries", icon: "truck", perm: "sales.deliveries.read" },
      ],
    },
  ],
  routes: [
    { path: "/orders", element: <OrdersList /> },
    { path: "/orders/:id", element: <OrderPage /> },
    { path: "/deliveries", element: <DeliveriesList /> },
    { path: "/deliveries/:id", element: <DeliveryPage /> },
  ],
  commands: [
    ["New sales order", "/orders/new", "plus", "sales.orders.write"],
    ["Sales orders", "/orders", "cart", "sales.orders.read"],
    ["Orders to deliver", "/orders?tab=to_deliver", "truck", "sales.orders.read"],
    ["Deliveries to ship", "/deliveries?tab=draft", "truck", "sales.deliveries.read"],
  ],
  newMenu: [
    { label: "Sales order", to: "/orders/new", perm: "sales.orders.write", key: "o", section: "Documents" },
  ],
  sources: { sales_order: "/orders/", delivery_note: "/deliveries/" },
  partyActions: [{ key: "so", kinds: ["customers"], perm: "sales.orders.write", component: NewOrderButton }],
  partyTabs: [
    {
      key: "orders",
      label: "Sales orders",
      kinds: ["customers"],
      perm: "sales.orders.read",
      component: CustomerOrdersTab,
    },
  ],
};
export default plugin;
